import React from "react";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = ({ isActive, ...rest }) => {
  return isActive ? (
    <svg xmlns="http://www.w3.org/2000/svg" {...rest} width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path
        d="M12.8774 9.63232C11.2206 9.63232 9.87744 8.28918 9.87744 6.63232C9.87744 4.97547 11.2206 3.63232 12.8774 3.63232C14.5343 3.63232 15.8774 4.97547 15.8774 6.63232C15.8774 8.28918 14.5343 9.63232 12.8774 9.63232Z"
        stroke="#F59C53"
        strokeWidth="1.5"
      />
      <path
        d="M6.3772 21.6323C4.72034 21.6323 3.3772 20.2892 3.3772 18.6323C3.3772 16.9755 4.72034 15.6323 6.3772 15.6323C8.03405 15.6323 9.3772 16.9755 9.3772 18.6323C9.3772 20.2892 8.03405 21.6323 6.3772 21.6323Z"
        stroke="#F59C53"
        strokeWidth="1.5"
      />
      <path
        d="M19.3777 21.6323C17.7208 21.6323 16.3777 20.2892 16.3777 18.6323C16.3777 16.9755 17.7208 15.6323 19.3777 15.6323C21.0345 15.6323 22.3777 16.9755 22.3777 18.6323C22.3777 20.2892 21.0345 21.6323 19.3777 21.6323Z"
        stroke="#F59C53"
        strokeWidth="1.5"
      />
      <path
        d="M20.8772 13.6319C20.8772 11.2425 19.8297 9.09773 18.1688 7.63184M4.8772 13.6319C4.8772 11.2425 5.92472 9.09773 7.58558 7.63184M10.8772 21.3798C11.5164 21.5444 12.1866 21.6319 12.8772 21.6319C13.5678 21.6319 14.238 21.5444 14.8772 21.3798"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" {...rest} width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path
        d="M12.8774 9.63232C11.2206 9.63232 9.87744 8.28918 9.87744 6.63232C9.87744 4.97547 11.2206 3.63232 12.8774 3.63232C14.5343 3.63232 15.8774 4.97547 15.8774 6.63232C15.8774 8.28918 14.5343 9.63232 12.8774 9.63232Z"
        stroke="#888888"
        strokeWidth="1.5"
      />
      <path
        d="M6.37793 21.6323C4.72108 21.6323 3.37793 20.2892 3.37793 18.6323C3.37793 16.9755 4.72108 15.6323 6.37793 15.6323C8.03478 15.6323 9.37793 16.9755 9.37793 18.6323C9.37793 20.2892 8.03478 21.6323 6.37793 21.6323Z"
        stroke="#888888"
        strokeWidth="1.5"
      />
      <path
        d="M19.377 21.6323C17.7201 21.6323 16.377 20.2892 16.377 18.6323C16.377 16.9755 17.7201 15.6323 19.377 15.6323C21.0338 15.6323 22.377 16.9755 22.377 18.6323C22.377 20.2892 21.0338 21.6323 19.377 21.6323Z"
        stroke="#888888"
        strokeWidth="1.5"
      />
      <path
        d="M20.8779 13.6319C20.8779 11.2425 19.8304 9.09773 18.1695 7.63184M4.87793 13.6319C4.87793 11.2425 5.92545 9.09773 7.58631 7.63184M10.8779 21.3798C11.5172 21.5444 12.1873 21.6319 12.8779 21.6319C13.5685 21.6319 14.2387 21.5444 14.8779 21.3798"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Icon;
